import { Injectable } from '@angular/core';
import { GqlServiceV2 } from '../../content/service/gql.service-v2';
import { abStatsFrag } from './types/ab-stats.gql-types';
import { AbStatsObject } from '@libs/types/src/inbox/object-type/ab-stats.object';
import { AbStatsGetInput } from '@libs/types/src/inbox/input-type/ab-stats.get-input';

@Injectable({ providedIn: 'root' })
export class AbStatsGqlService extends GqlServiceV2 {

    getAbStats(input: AbStatsGetInput, frag: string = abStatsFrag) {
        return this.query<AbStatsObject>(
            `
                query($input: AbStatsGetInput!) {
                    abStats {
                        get(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }
}
